import React, { useEffect, useState } from "react";
import CommonCardComponent from "../../../../components/common/CommonCardComponent";
import InputFieldsComponent from "../../../../components/common/InputFieldsSmall";
import './VerificationModal.css';
import Button from "../../../../components/common/Button";
import abhaImg from '../../../../assets/png/ABHA.png'
import aadharImg from '../../../../assets/png/AADHAAR.png'
import FaceAuthImg from '../../../../assets/svg_main/beneficiary/Face Authentication.svg'
import finish from '../../../../assets/png/celebration.png'
import { initial } from "lodash";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/reducers";
import FormFields from "../../../Forms/FormFields";
import { abhaVerify } from "../../../../constants";
import { Link } from "react-router-dom";
import Time from "./time";
import endpoints from "../../../../config/endpoints";
import Spinner from "@components/common/Spinner";
import { getData, postDataJSON } from "../../../../services/CommonApiService";
import { getUserConsentLanguage } from '@services/childApiServices';
import CheckboxComponent from "@components/common/CheckBox";
import calculateStringSimilarity from "../../../../utils/calculateStringSimilarity";
import { encode, decode, encodeWithKeyAndShift, decryptData, decodeWithKeyAndShift } from '../../../../utils/base64Utils';
import { errorLogger } from '@utils/applicationLogUtils';
import { useDispatch } from 'react-redux';
import { updateForm } from '../../../../store/actions/userManagementAction';
import { setBeneficiaryAuthType } from '../../../../store/actions/beneficiaryAction';
import { benef_const } from '@constants/beneficiaryConstant';
import { toast } from "react-toastify";
import AadharModal from '../../../Beneficiary-block/CreateBeneficiary/Aadhar';
import FaceAuthenticationModal from '../../../Beneficiary-block/CreateBeneficiary/FaceAuthenticationModal';
import { useOtpCooldown, startOtpCooldown, isOtpRateLimitedError } from '@hooks/useOtpCooldown';
import { otpCooldownMessage } from "@constants/appConstants";

interface VerificationCardProps {
    cardContent1Header?: string;
    cardContent2Header?: string;
    cardContent3Header?: string;
    closeLastCard: () => void;
    handleVerify: (value: boolean, input: string) => void;
}

interface objectType {
    isError: boolean,
    message: string,
    isDisable: boolean,
    value: any,
}
interface formStateType {
    [key: string]: objectType
}

const VerificationCard: React.FC<VerificationCardProps> = ({ closeLastCard, handleVerify, cardContent1Header, cardContent2Header, cardContent3Header }) => {
    const [index, setIndex] = useState<number>(0);
    const [selectedInputFieldValue, setSelectedInputFieldValue] = useState<string[]>([]);
    const [saveContent1, setSaveContent1] = useState<boolean>(true);
    const [saveContent2, setSaveContent2] = useState<boolean>(false);
    const [saveContent3, setSaveContent3] = useState<boolean>(false);
    const [saveContent4, setSaveContent4] = useState<boolean>(false);
    const [saveContent5, setSaveContent5] = useState<boolean>(false);
    const [saveContent6, setSaveContent6] = useState<boolean>(false);
    const [saveContent7, setSaveContent7] = useState<boolean>(false);
    const [showFaceAuthModal, setShowFaceAuthModal] = useState<boolean>(false);
    const [dummyLinkedBenefDetails, setDummyLinkedBenefDetails] = useState<string>('');
    const hfrAbhaId = useSelector((state: RootState) => state.user.hfrAbha);
    const fName = useSelector((state: RootState) => state.user.fName);
    const lName = useSelector((state: RootState) => state.user.lName);
    const beneficiaryMobileNumber = useSelector((state: RootState) => state.beneficiary.beneficiaryMobileNumber);
    const [resetKey, setResetKey] = useState<number>(0);
    const [showSpinner, setSHowSpinner] = useState<boolean>(false);
    const [isTimeFinished, setIsTimeFinished] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState<string>('');
    const [mobileValue, setMobileValue] = useState<string>('');
    const [inputAbha, setInputAbha] = useState<string>(hfrAbhaId);
    const [idValue, setIdValue] = useState<string>(hfrAbhaId);
    const [aadharTxnId, setAadharTxnId] = useState<string>('');
    const [abhaTxnId, setAbhaTxnId] = useState<string>('');
    const [otpTxnId, setOtpTxnId] = useState<string>('');
    const [isHPRError, setIsHPRError] = useState<boolean>(false);
    const [isAadharError, setIsAadharError] = useState<boolean>(false);
    const [isAbhaError, setIsAbhaError] = useState<boolean>(false);
    const [isMobileError, setIsMobileError] = useState<boolean>(false);
    const [consentCheckbox, setConsentCheckbox] = useState<boolean>(false);
    const [isAbhaCreate, setIsAbhaCreate] = useState<boolean>(false);
    const [isHPRErrorCheck, setIsHPRErrorCheck] = useState<boolean>(true);
    const [isAadharErrorCheck, setIsAadharErrorCheck] = useState<boolean>(true);
    const [isOTPErrorCheck, setIsOTPErrorCheck] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(true);
    const [aadharErrorMessage, setAadharErrorMessage] = useState<string>('');
    const [mobileErrorMessage, setMobileErrorMessage] = useState<string>('');
    const [abhaErrorMessage, setAbhaErrorMessage] = useState<string>('');
    const [hprErrorMessage, setHprErrorMessage] = useState<string>('');
    const [hprMessage, setHprMessage] = useState<string>('');
    const [abhaMessage, setAbhaMessage] = useState<string>('');
    const [otpWrong, setOtpWrong] = useState<string>('');
    const [retryMessage, setRetryMessage] = useState<string>('');
    const [resData, setResData] = useState<any>();
    const [resAadharData, setResAadharData] = useState<any>();
    const [retry, setRetry] = useState<number>(benef_const.defalut_retry);
    const [consentLanguageData, setConsentLanguageData] = useState<any>([]);
    const [consentShowFacilityLevel, setConsentShowFacilityLevel] = useState<boolean>(false);
    const [facilityLevelConsentCheckbox, setFacilityLevelConsentCheckBox] = useState<boolean>(false);
    const [checkedState, setCheckedState] = useState<boolean[]>([]);
    const [consentShowAbha, setConsentShowAbha] = useState<boolean>(false);
    const [checkedStateFacility, setCheckedStateFacility] = useState<boolean>(false)
    const dispatch = useDispatch();
    const abhaCooldown = useOtpCooldown(inputAbha);
    const aadhaarCooldown = useOtpCooldown(inputValue);
    const isAllChecked = checkedState?.every((checked) => checked);

    useEffect(() => {
        if (userTypeData == 'Facility Level User') {
            getConsentLanguage('User', 'hrp');            
        }
    }, []);

    useEffect(() => {
        const fetchVerificationProcesses = async () => {
            try {
                const response = await getData<any>(`${endpoints.getVerificationProcess}`);
                if (response?.data) {
                    setVerificationProcesses(response.data);
                }
            } catch (error: any) {
                errorLogger(error?.response?.data || error?.response || error);
            }
        };
        fetchVerificationProcesses();
    }, []);

    const getConsentLanguageField = async (type: string, consent: string) => {
        try {
            const response = await getUserConsentLanguage(type, consent);
            setConsentLanguageData(response);
            const res: any = response?.data[0]?.length // 6
            setCheckedState(new Array(res).fill(false))
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
        }
    };

    const getConsentLanguage = async (type: string, consent: string) => {
        try {
            const response = await getUserConsentLanguage(type, consent);
            const templateContent = response.data[0][0]['consent_template_content'].replace(
                '{#var1#}', `${fName} ${lName}`)

            const consentDetails = [{
                'consent_template_id': response.data[0][0]['consent_template_id'],
                'conscent_template_content': templateContent
            }]
            
            setConsentLanguageData(consentDetails);
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
        }
    };

    const restartTimer = async () => {
        setIsOTPErrorCheck(true);
        if (retry <= 0) {
            setRetryMessage('otp limit reached ');
            if (userTypeData === 'Facility Level User') {
                setHprMessage('Maximum limit to resend OTP is reached. Please try after some time.')
                setSaveContent3(true);
                setSaveContent2(false);
                handleVerify(false, idValue);
            }
            else {
                setAbhaMessage('Maximum limit to resend OTP is reached. Please try after some time.')
                setSaveContent3(true);
                setSaveContent2(false);
                handleVerify(false, inputAbha);
            }
        }

        else {
            setResetKey(prevKey => prevKey + 1);
            setIsTimeFinished(false);
            setRetry(retry - 1);
            setOtpWrong('');
            setRetryMessage('');
            if (userTypeData === 'Facility Level User' && userDesignationData !== 'MPW/MPHW') {
                const result = selectedInputFieldValue.join('');
                if (inputValue && idValue) {
                    const data = {
                        "aadhaar": inputValue
                    }
                    try {
                        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                        const aadharResponse = await postDataJSON<any>(`${endpoints.sendOtpToAadharToVerifyhpr}`, { data: encodedPayload })
                        const decodedData = JSON.parse(decodeWithKeyAndShift(aadharResponse.data));
                        const res = decodedData;
                        if (res.txnId) {
                            setAadharTxnId(res.txnId);
                            // setOtpTxnId(res.txnId);
                            //setIsOTPErrorCheck(false);
                            // setSaveContent2(true);
                            // setSaveContent1(false);
                        }
                        else {
                            const errorMessage = (<div>
                                    <p><strong>ABDM:</strong> {res?.error||res?.data||res?.message||res?.code||res}</p >
                                </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                            setOtpWrong('Unable to contact ABDM services')
                        }
                    }
                    catch (error:any) {
                      if(error?.response?.data?.data||error?.response?.data){
                        errorLogger(error?.response?.data?.data||error?.response?.data||error?.response||error,"Aadhar OTP Generation ERROR-sendOtpToAadharToVerifyhpr");
                        setOtpWrong('Unable to contact ABDM services');
                        const errorData=error?.response?.data?.data;
                        if(errorData){
                            if(errorData?.code && errorData?.message){
                               const errorMessage = (<div>
                                   <p><strong>ABDM:</strong> {`${errorData?.code} ${errorData?.message}`}</p >
                               </div>);
                               toast.error(errorMessage, {
                                   position: "top-center",
                               });
                            }
                            else if((errorData?.message||errorData?.code)&& errorData?.details){
                                const errorMessage = (<div>
                                    <p><strong>ABDM:</strong> {`${(errorData?.message||errorData?.code)} ${errorData?.details}`}</p >
                                </div>);
                                toast.error(errorMessage, {
                                    position: "top-center",
                                });
                            }
                            else if(errorData?.message||errorData?.code|| errorData?.details||errorData?.data||errorData){
                                const errorMessage = (<div>
                                    <p><strong>ABDM:</strong> {errorData?.message||errorData?.code || errorData?.details||errorData?.data||errorData}</p >
                                </div>);
                                toast.error(errorMessage, {
                                    position: "top-center",
                                });
                            }
                        }
                        else{
                             const errorMessage = (<div>
                                    <p><strong>ABDM:</strong> {error?.response?.data?.data||error?.response?.data||error?.response||error}</p >
                                </div>);
                                toast.error(errorMessage, {
                                    position: "top-center",
                                });
                        }
                    }
                    else{
                        toast.error(error, {
                                    position: "top-center",
                                });
                        setOtpWrong('Unable to contact ABDM services');
                    }
                    }
                }
            }
            else if (userTypeData === 'Field Level User' || (userTypeData === 'Facility Level User' && userDesignationData === 'MPW/MPHW')) {
                const result = selectedInputFieldValue.join('');
                if (inputAbha) {
                    const formattedNum = formatNumber(inputAbha);
                    const data = {
                        "abhaNumber": formattedNum
                    }
                    try {
                        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                        const abhaResponse = await postDataJSON<any>(`${endpoints.sendOtpToAbhaToVerifyAbha}`, { data: encodedPayload })
                        const decodedData = JSON.parse(decodeWithKeyAndShift(abhaResponse.data));
                        const res = decodedData;

                        if (res?.txnId) {
                            setAbhaTxnId(res?.txnId);
                            //setOtpTxnId(res.authResult);
                            // setIsOTPErrorCheck(false);
                            // setSaveContent2(true);
                            // setSaveContent1(false);
                        }
                         else if (res?.message?.includes('multiple OTPs')) {
                            const errorMessage = (<div>
                            <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                            </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                            setOtpWrong('You have requested multiple OTPs')                    
                        }
                        else if (res?.message?.includes('30 seconds')) {
                            const errorMessage = (<div>
                            <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                            </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                            setOtpWrong('Request for new OTP after timer ends.')
                        }
                        else if (res?.message?.includes('Too many request attempted')) {
                            const errorMessage = (<div>
                            <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                            </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                            setOtpWrong('Too many request attempted in short period of time')
                        }                   
                        else if(res?.message==='User not found.') {
                            const errorMessage = (<div>
                            <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                            </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                            setOtpWrong('Entered Abha Number is incorrect')
                        }
                        else {
                            const errorMessage = (<div>
                            <p><strong>ABDM:</strong> {((res?.code && res?.message)||(res?.code || res?.message))? (`${res?.code?res?.code:''} ${res?.message?res?.message:''} ${res?.description?res?.description:''}`):res}</p >
                            </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                            setOtpWrong('Unable to contact ABDM services')
                            errorLogger(res,"Abha OTP Generation-sendOtpToAbhaToVerifyAbha");
                        }
                        
                    }
                    catch (error:any) {
                     if (isOtpRateLimitedError(error)) {
                        startOtpCooldown(inputAbha);
                        setOtpWrong(otpCooldownMessage);
                        toast.error(otpCooldownMessage, { position: "top-center" });
                        return;
                     }
                     if(error?.response?.data){
                        const decodedData = JSON.parse(decodeWithKeyAndShift(error?.response?.data));
                        const res = decodedData;
                        const errorMessage = (<div>
                        <p><strong>ABDM:</strong> {((res?.code && res?.message)||(res?.code || res?.message))? (`${res?.code?res?.code:''} ${res?.message?res?.message:''} ${res?.description?res?.description:''}`):res?.data?(res?.data?.code || res?.data?.message||res?.data?.description)?`${res?.data?.code?res?.data?.code:''} ${res?.data?.message?res?.data?.message:''} ${res?.data?.description?res?.data?.description:''}`:res?.data:res}</p >
                        </div>);
                        toast.error(errorMessage, {
                            position: "top-center",
                        });
                        errorLogger(res,"Abha OTP Generation-sendOtpToAbhaToVerifyAbha");
                        setOtpWrong('Unable to contact ABDM services');
                    }
                    else{
                        setOtpWrong('Unable to contact ABDM services');
                        toast.error(error, {
                            position: "top-center",
                        });
                    }
                    }
                }
                else if (isAbhaCreate && inputValue) {
                    const data = {
                        "aadhaar": inputValue
                    }
                    try {
                        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                        const aadharResponse = await postDataJSON<any>(`${endpoints.createAbhaViaAadhaar}`, { data: encodedPayload })
                        const decodedData = JSON.parse(decodeWithKeyAndShift(aadharResponse.data));
                        const res = decodedData
                        if (res.txnId) {
                            setAadharTxnId(res.txnId);
                            //setIsOTPErrorCheck(false);
                        }
                        else {
                            if (res?.message?.includes('multiple OTPs')) {
                                setSHowSpinner(false);
                                setOtpWrong('You have requested multiple OTPs');
                                const errorMessage = (<div>
                                <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                                </div>);
                                toast.error(errorMessage, {
                                    position: "top-center",
                                });
                            }
                            else if (res?.message?.includes('30 seconds')) {
                                setSHowSpinner(false);
                                setOtpWrong("You can request for new OTP")
                                const errorMessage = (<div>
                                <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                                </div>);
                                toast.error(errorMessage, {
                                    position: "top-center",
                                });
                            }
                            else if (res?.message?.includes('Too many request attempted')) {
                                setOtpWrong("Too many request attempted")
                                const errorMessage = (<div>
                                <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                                </div>);
                                toast.error(errorMessage, {
                                    position: "top-center",
                                });
                            }
                            else{
                                setOtpWrong("Unable to contact ABDM services");
                                errorLogger(res,"Aadhar OTP Generation ERROR-createAbhaViaAadhaar");
                                const errorMessage = (<div>
                                <p><strong>ABDM:</strong> {((res?.code && res?.message)||(res?.code || res?.message || res?.loginId))? (`${res?.code?res?.code:''} ${res?.message?res?.message:''} ${res?.description?res?.description:''} ${res?.loginId?res?.loginId:''}`):JSON.stringify(res)}</p >
                                </div>);
                                toast.error(errorMessage, {
                                    position: "top-center",
                                });
                            }
                         }
                    }
                    catch (error:any) {
                        if (isOtpRateLimitedError(error)) {
                            startOtpCooldown(inputValue);
                            setOtpWrong(otpCooldownMessage);
                            toast.error(otpCooldownMessage, { position: "top-center" });
                            return;
                        }
                        if(error?.response?.data){
                            const decodedData = JSON.parse(decodeWithKeyAndShift(error?.response?.data));
                            const res = decodedData;
                            errorLogger(res,"Abha OTP Generation-createAbhaViaAadhaar");
                            setOtpWrong('Unable to contact ABDM services');
                             const errorMessage = (<div>
                             <p><strong>ABDM:</strong> {((res?.code && res?.message)||(res?.code || res?.message))? (`${res?.code?res?.code:''} ${res?.message?res?.message:''} ${res?.description?res?.description:''}`):res?.data?(res?.data?.code || res?.data?.message||res?.data?.description)?`${res?.data?.code?res?.data?.code:''} ${res?.data?.message?res?.data?.message:''} ${res?.data?.description?res?.data?.description:''}`:res?.data:res}</p >
                            </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                        }
                        else{
                            setOtpWrong('Unable to contact ABDM services');
                            toast.error(error, {
                                position: "top-center",
                            });
                        }
                      
                    }
                }
            }
        }
    }
    const handleTimerEnd = () => {
        setIsTimeFinished(true);
    }
    const handleFormChange = (event: any) => {
        setIdValue(event);
        setIsHPRErrorCheck(true);
        setIsHPRError(false);
        setError(true);
    }

    const handleFormChangeAbha = (event: any) => {
        const numericValue = event.replace(/\D/g, '');
        setInputAbha(numericValue);
        setIsAbhaError(false);
        setError(true);
        setAbhaErrorMessage('');
    }
    const handleAadharChange = (event: any) => {
        const numericValue = event.replace(/\D/g, '');
        setInputValue(numericValue);
        setIsAadharErrorCheck(true);
        setIsAadharError(false);
        setError(true);
    }
    const handleMobileChange = (event: any) => {
        const numericValue = event.replace(/\D/g, '');
        setMobileValue(numericValue);
        setIsMobileError(false);
        setError(true);
    }
    const [roleFormState, setRoleFormState] = useState<formStateType>({
        mfa: {
            isError: false,
            message: '',
            isDisable: false,
            value: false,
        }
    });

    const userTypeData = useSelector((state: RootState) => state.user.userType)
    const userDesignationData = useSelector((state: RootState) => state.user.designation)
    const [hfrData, setHfrData] = useState<string>('')
    const [abhaData, setAbhaData] = useState<string>('')
    const [verificationProcesses, setVerificationProcesses] = useState<any[]>([]);
    const hfrId = useSelector((state: RootState) => state.user.hfr);
    const [consentShowAdhar, setConsentShowAdhar] = useState<boolean>(false);
    const abhaId = useSelector((state: RootState) => state.user.hfrAbha);
    const showAdharConsentForm = () => {
        if (consentLanguageData?.length === 0) {
            toast.error("Unable to fetch consent details. Please try again later.", {
                position: "top-center",
            });
            return;
        }
        setConsentShowAdhar(true);
        setSaveContent6(true);
        setSaveContent5(false);
    }

    const showAbhaConsentForm = () => {
        if (consentLanguageData?.length === 0) {
            toast.error("Unable to fetch consent details. Please try again later.", {
                position: "top-center",
            });
            return;
        }
        setConsentShowAbha(true);
        setSaveContent4(false);
    }

    const showConsentFormFacilityLevel = () => {
        if (consentLanguageData?.length === 0) {
            toast.error("Unable to fetch consent details. Please try again later.", {
                position: "top-center",
            });
            return;
        }
        setConsentShowFacilityLevel(true);
        setSaveContent1(false);
    };

    const handleLast = () => {
        closeLastCard();
        setSaveContent3(false);
    }
    const handletoAadharFieldLevel = () => {
        setConsentCheckbox(true);
        setSaveContent5(true);
        setConsentShowAdhar(false);
    }

    const handletoAbhaFieldLevel = () => {
        setConsentCheckbox(true);
        setSaveContent4(true);
        setConsentShowAbha(false);
    }

    const handletoAadharFacilityLevel = () => {
        // dispatch(updateForm("consentDetails",consentLanguageData));
        setFacilityLevelConsentCheckBox(true)
        setSaveContent1(true);
        setConsentShowFacilityLevel(false)
    }

    const showAbha = () => {
        const process = verificationProcesses.find((p: any) => p.verification_process_code === 'ABHAVerification');
        if (process) {
            dispatch(updateForm("verificationProcessId", process.verification_process_id));
        }
        setSaveContent4(true);
        setSaveContent1(false);
        getConsentLanguageField('User', 'abha');
    }
    const showAadhar = () => {
        const process = verificationProcesses.find((p: any) => p.verification_process_code === 'AadharVerification');
        if (process) {
            dispatch(updateForm("verificationProcessId", process.verification_process_id));
        }
        setSaveContent5(true);
        setSaveContent1(false);
        getConsentLanguageField('User', 'aadhaar');
    }

    const showAadharMobile = () => {
        const process = verificationProcesses.find((p: any) => p.verification_process_code === 'FaceAuthentication');
        if (process) {
            dispatch(updateForm("verificationProcessId", process.verification_process_id));
        }
        dispatch(setBeneficiaryAuthType('Face_Auth_Creation'));
        setSaveContent7(true);
        setSaveContent1(false);
    };
    const handleFaceAuthModalClose = (type: string) => {
        setSaveContent7(false);
        if (type === 'submit') {
            // Aadhaar, Name & Mobile are saved in Redux — now show the Face Authentication QR modal
            setShowFaceAuthModal(true);
        } else {
            setSaveContent1(true);
        }
    };

    const closeFaceAuthModal = async (type: string, verifiedBeneficiaryData?: any) => {
        setShowFaceAuthModal(false);
        if (type === 'back') {
            // Go back to the AadharModal so user can re-enter details
            dispatch(setBeneficiaryAuthType('Face_Auth_Creation'));
            setSaveContent7(true);
        } else if (type === 'submit') {
            // Face authentication completed — check if ABHA is already linked then check name similarity
            const abhaName = verifiedBeneficiaryData?.name || '';
            const abhaId = verifiedBeneficiaryData?.abhaId || '';

            // Check if ABHA is already linked to another user
            try {
                const dataAbha = { abhaId: abhaId };
                const encodedNumber = encodeWithKeyAndShift(JSON.stringify(dataAbha));
                const abhaResponse = await postDataJSON<any>(`${endpoints.checkABHAIdExists}`, { data: encodedNumber });
                const decodedResponse = JSON.parse(decodeWithKeyAndShift(abhaResponse.data));
                const abhaRes = decodedResponse[0];
                if (abhaRes?.check_abha_id_exists) {
                    setSaveContent3(true);
                    setAbhaMessage('Entered Abha number is already linked with another user.');
                    handleVerify(false, abhaId);
                    return;
                }
            } catch (error: any) {
                errorLogger(error?.response?.data || error?.response || error, 'Face Auth - Check ABHA Exists');
                toast.error('Failed to verify ABHA number. Please try again.', { position: 'top-center' });
                setSaveContent1(true);
                return;
            }

            if (beneficiaryMobileNumber) {
                dispatch(updateForm('mob', beneficiaryMobileNumber));
            }
            let concatEnteredName = '';
            if (hasMultipleWords(abhaName)) {
                concatEnteredName = `${fName} ${lName}`;
            } else {
                concatEnteredName = `${fName}`;
            }
            const isNameSimilar = calculateStringSimilarity(abhaName, concatEnteredName);
            setSaveContent3(true);
            if (isNameSimilar) {
                setAbhaMessage('Face Authentication completed successfully.');
                handleVerify(true, abhaId);
            } else {
                setAbhaMessage('Your ABHA Number not verified. First Name / Last Name does not match with ABHA details. Please check again and proceed.');
                handleVerify(false, abhaId);
            }
        } else {
            // 'close' — discard and go back to main selection
            setSaveContent1(true);
        }
    };

    const isError: boolean[] = [];

    const handleSave1 = async () => {
        if (inputValue.length === 0) {
            setIsAadharErrorCheck(true);
            setAadharErrorMessage("Aadhaar number is required. Enter a valid Aadhaar number")
            setIsAadharError(true);
            isError[0] = true;
        }
        else if (inputValue.length !== 12) {
            setIsAadharErrorCheck(true);
            setAadharErrorMessage("Aadhaar number Must Contain 12 Digits. Enter a valid Aadhaar number.")
            setIsAadharError(true);
            isError[0] = true;
        }
        else {
            setIsAadharErrorCheck(false);
            setIsAadharError(false);
            isError[0] = false;
        }

        if (idValue.length === 0) {
            setIsHPRErrorCheck(true);
            setHprErrorMessage("HPR ID is required. Enter a valid HPR ID")
            setIsHPRError(true);
            isError[1] = true;
        }
        else if (idValue.length !== 14) {
            setIsHPRErrorCheck(true);
            setHprErrorMessage("HPR ID Must Contain 14 Digits. Enter a valid HPR ID.")
            setIsHPRError(true);
            isError[1] = true;
        }
        else {
            setIsHPRErrorCheck(false);
            setIsHPRError(false);
            isError[1] = false;
        }
        if (isError[1] === false && isError[0] === false && facilityLevelConsentCheckbox) {
            const data = {
                "aadhaar": inputValue
            }
            try {
                const dataHpr = {
                    hprId: idValue
                }
                const encodedNumber = encodeWithKeyAndShift(JSON.stringify(dataHpr));
                const hprResponse = await postDataJSON<any>(`${endpoints.checkHPRIdExists}`, { data: encodedNumber });
                const decodedResponse = JSON.parse(decodeWithKeyAndShift(hprResponse.data));
                const hprRes = decodedResponse[0];
                const hprFlag = hprRes?.exists_flag;
                if (hprFlag) {
                    setIsHPRErrorCheck(true);
                    setHprErrorMessage(`Entered HPR ID is already linked with mobile number ${hprRes?.mob}.`)
                    setIsHPRError(true);
                }
                else {
                    try {
                        setSHowSpinner(true);
                        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                        const aadharResponse = await postDataJSON<any>(`${endpoints.sendOtpToAadharToVerifyhpr}`, { data: encodedPayload })
                        const decodedData = JSON.parse(decodeWithKeyAndShift(aadharResponse.data));
                        const res = decodedData
                        setSHowSpinner(false)
                        if (res.txnId) {

                            setAadharTxnId(res.txnId);
                            setError(false);
                            setSaveContent2(true);
                            setSaveContent1(false);
                        }
                        else {
                            setSHowSpinner(false)
                            setIsAadharErrorCheck(true);
                            errorLogger(res,"Aadhar OTP ERROR-sendOtpToAadharToVerifyhpr");
                            setAadharErrorMessage("Unable to contact ABDM services. Please try again after some time.")
                            setIsAadharError(true);
                            const errorMessage = (<div>
                                    <p><strong>ABDM:</strong> {res?.error||res?.data||res?.message||res?.code||res}</p >
                                </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                        }
                    }
                    catch (error:any) {
                        setSHowSpinner(false)
                        setIsAadharErrorCheck(true);
                        errorLogger(error?.response?.data?.data||error?.response?.data||error?.response||error,"Aadhar OTP Generation ERROR-sendOtpToAadharToVerifyhpr");
                        setIsAadharError(true);
                        const errorData=error?.response?.data?.data;
                        if(errorData){
                            if(errorData?.code && errorData?.message && errorData?.details?.length>0){
                               const errorMessage = (<div>
                                   <p><strong>ABDM:</strong> {(errorData?.details[0]?.code||errorData?.code)+" "+(errorData?.details[0]?.message||errorData?.message)}</p >
                               </div>);
                               toast.error(errorMessage, {
                                   position: "top-center",
                               });
                               errorData?.code==="HIS-422" && errorData?.details[0]?.code==='HIS-2001'?
                                setAadharErrorMessage("Entered Aadhaar Number is Incorrect. Please enter correct Aadhaar Number."):
                                setAadharErrorMessage("Unable to contact ABDM services. Please try again after some time.");
                            }
                            else if(errorData?.code && errorData?.message){
                               const errorMessage = (<div>
                                   <p><strong>ABDM:</strong> {errorData?.code+" "+errorData?.message}</p >
                               </div>);
                               toast.error(errorMessage, {
                                   position: "top-center",
                               });
                               errorData?.code==="HIS-422" && errorData?.details[0]?.code==='HIS-2001'?
                                setAadharErrorMessage("Entered Aadhaar Number is Incorrect. Please enter correct Aadhaar Number."):
                                setAadharErrorMessage("Unable to contact ABDM services. Please try again after some time.");
                            }
                            else if((errorData?.message||errorData?.code)&& errorData?.details){
                                const errorMessage = (<div>
                                    <p><strong>ABDM:</strong> {(errorData?.message||errorData?.code)+" "+errorData?.details}</p >
                                </div>);
                                toast.error(errorMessage, {
                                    position: "top-center",
                                });
                                 setAadharErrorMessage("Unable to contact ABDM services. Please try again after some time.");
                            }
                            else if(errorData?.code|| errorData?.message||errorData?.details||errorData?.data||errorData){
                                const errorMessage = (<div>
                                    <p><strong>ABDM:</strong> {errorData?.code||errorData?.message || errorData?.details||errorData?.data||errorData}</p >
                                </div>);
                                toast.error(errorMessage, {
                                    position: "top-center",
                                });
                                 setAadharErrorMessage("Unable to contact ABDM services. Please try again after some time.");
                            }
                        }
                        else{
                             const errorMessage = (<div>
                                    <p><strong>ABDM:</strong> {error?.response?.data?.data||error?.response?.data||error?.response||error}</p >
                                </div>);
                                toast.error(errorMessage, {
                                    position: "top-center",
                                });
                           setAadharErrorMessage("Unable to contact ABDM services. Please try again after some time.");
                        }
                    }
                }
            }
            catch (error:any) {
                setIsHPRErrorCheck(true);
                setHprErrorMessage("Failed to verify HPR ID internally. Please try again.")
                setIsHPRError(true);
                errorLogger(error?.response?.data?.messages,"HPR Verification-HPRID exists");
            }


        }
    }
    const formatNumber = (num: string): string => {
        // Split the number into parts
        const part1 = num.slice(0, 2);
        const part2 = num.slice(2, 6);
        const part3 = num.slice(6, 10);
        const part4 = num.slice(10);

        // Join the parts with hyphens
        return `${part1}-${part2}-${part3}-${part4}`;
    };

    const handleSaveAbha = async () => {
        if (inputAbha.length === 0) {
            setAbhaErrorMessage("ABHA Number is required. Enter a valid ABHA.")
            setIsAbhaError(true);
        }
        else if (!/^\d+$/.test(inputAbha)) {
            setAbhaErrorMessage("ABHA Number contains invalid Characters. Enter a Valid ABHA Number.")
            setIsAbhaError(true);
        }
        else if (inputAbha.length !== 14) {
            setAbhaErrorMessage("ABHA Number Must Contain 14 Digits. Enter a valid ABHA Number.")
            setIsAbhaError(true);
        }
        else if (inputAbha == '00000000000000') {
            setAbhaErrorMessage("ABHA Cannot be all Zeros. Enter a valid ABHA Number.")
            setIsAbhaError(true);
        }
        else {
            setIsAbhaError(false);
            const formattedNum = formatNumber(inputAbha);
            const data = {
                "abhaNumber": formattedNum
            }
            try {
                const dataAbha = {
                    abhaId: inputAbha
                }
                const encodedNumber = encodeWithKeyAndShift(JSON.stringify(dataAbha));
                const abhaResponse = await postDataJSON<any>(`${endpoints.checkABHAIdExists}`, { data: encodedNumber });
                const decodedResponse = JSON.parse(decodeWithKeyAndShift(abhaResponse.data));
                const abhaRes = decodedResponse[0];
                const abhaFlag = abhaRes.check_abha_id_exists;
                if (abhaFlag) {
                    setAbhaErrorMessage("Entered  Abha number is already linked with another user.")
                    setIsAbhaError(true);
                }
                else {
                    try {
                        setSHowSpinner(true);
                        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                        const abhaResponse = await postDataJSON<any>(`${endpoints.sendOtpToAbhaToVerifyAbha}`, { data: encodedPayload })
                        const decodedData = JSON.parse(decodeWithKeyAndShift(abhaResponse.data));
                        const res = decodedData
                        const consentDetails = [
                            ...consentLanguageData.data[0].map((item:any) => ({
                                consent_template_id: item.consent_template_id,
                                conscent_template_content: item?.consent_template_content.includes('{#name#}')
                                ? item?.consent_template_content.replace(
                                    '{#name#}',
                                    `${fName} ${lName}`
                                )
                                : item?.consent_template_content
                            })),
                        ];
                        dispatch(updateForm("consentDetails", consentDetails));
                        setSHowSpinner(false);
                        if (res.txnId) {
                            setAbhaTxnId(res.txnId);
                            setError(false);
                            setSaveContent2(true);
                            setSaveContent4(false);
                        }
                        else if (res?.message?.includes('multiple OTPs')) {
                            const errorMessage = (<div>
                            <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                            </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                            setSHowSpinner(false);
                            setAbhaErrorMessage("You have requested multiple OTPs Or Exceeded maximum number of attempts for OTP match in this transaction. Please try again in 30 minutes.")
                            setIsAbhaError(true);
                        }
                        else if (res?.message?.includes('30 seconds')) {
                            const errorMessage = (<div>
                            <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                            </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                            setSHowSpinner(false);
                            setAbhaErrorMessage("You can request for new OTP after 30 seconds.")
                            setIsAbhaError(true);
                        }
                        else if (res?.message?.includes('Too many request attempted')) {
                            const errorMessage = (<div>
                            <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                            </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                            setSHowSpinner(false);
                            setAbhaErrorMessage("Too many request attempted in short period of time. Please try again in 30 minutes.")
                            setIsAbhaError(true);
                        }                   
                        else if(res?.message==='User not found.') {
                            setSHowSpinner(false);
                            setIsAbhaError(true);
                            const errorMessage = (<div>
                            <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                            </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                            setAbhaErrorMessage('Entered Abha Number is incorrect.Please enter correct Abha Number.')
                        }
                        else {
                            const errorMessage = (<div>
                            <p><strong>ABDM:</strong> {((res?.code && res?.message)||(res?.code || res?.message))? (`${res?.code?res?.code:''} ${res?.message?res?.message:''} ${res?.description?res?.description:''}`):res}</p >
                            </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                            setSHowSpinner(false);
                            setAbhaErrorMessage("Unable to contact ABDM services. Please try again after some time.")
                            setIsAbhaError(true);
                            errorLogger(res,"Abha OTP Generation-sendOtpToAbhaToVerifyAbha");

                        }
                    }
                    catch (error:any) {
                     if (isOtpRateLimitedError(error)) {
                        abhaCooldown.startCooldown();
                        setSHowSpinner(false);
                        setIsAbhaError(true);
                        setAbhaErrorMessage("You can request for new OTP after 30 seconds.");
                        toast.error(otpCooldownMessage, { position: "top-center" });
                        return;
                     }
                     if(error?.response?.data){
                        const decodedData = JSON.parse(decodeWithKeyAndShift(error?.response?.data));
                        const res = decodedData;
                        if(res?.message==='User not found.'){
                            const errorMessage = (<div>
                            <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                            </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                            setAbhaErrorMessage('Entered Abha Number is incorrect.Please enter correct Abha Number.')
                        }
                        else{
                            const errorMessage = (<div>
                            <p><strong>ABDM:</strong> {((res?.code && res?.message)||(res?.code || res?.message))? (`${res?.code?res?.code:''} ${res?.message?res?.message:''} ${res?.description?res?.description:''}`):res?.data?(res?.data?.code || res?.data?.message||res?.data?.description)?`${res?.data?.code?res?.data?.code:''} ${res?.data?.message?res?.data?.message:''} ${res?.data?.description?res?.data?.description:''}`:res?.data:res}</p >
                            </div>);
                            toast.error(errorMessage, {
                                position: "top-center",
                            });
                            setAbhaErrorMessage('Unable to contact ABDM services. Please try again after some time.')
                        }
                        setSHowSpinner(false);
                        errorLogger(res,"Abha OTP Generation-sendOtpToAbhaToVerifyAbha");
                        setIsAbhaError(true);
                    }
                    else{
                        setSHowSpinner(false);
                        errorLogger(error,"Abha OTP Generation-sendOtpToAbhaToVerifyAbha");
                        setIsAbhaError(true);
                        setAbhaErrorMessage('Unable to contact ABDM services. Please try again after some time.')
                        toast.error(error, {
                            position: "top-center",
                        });
                    }
                    }
                }
            }
            catch (error:any) {
                errorLogger(error?.response?.data?.messages,"Abha Exists Api fails");
                setAbhaErrorMessage('Failed to verify Abha Number internally. Please try again.')
                setIsAbhaError(true);
            }
        }
    }
    const hasMultipleWords = (input: string): boolean => {
        return input.trim().indexOf(' ') !== -1;
    }
    //otp save
    const handleSave2 = async () => {
        if (userTypeData === 'Facility Level User' && userDesignationData !== 'MPW/MPHW') {
            if (selectedInputFieldValue.length === 6) {
                const result = selectedInputFieldValue.join('');
                if (inputValue && idValue) {
                    const data = {
                        "otp": result,
                        "txnId": aadharTxnId
                    }
                    try {
                        setSHowSpinner(true);
                        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));

                        const otpResponse = await postDataJSON<any>(`${endpoints.verifyOtpToAadharToVerifyhpr}`, { data: encodedPayload })
                        const decodedData = JSON.parse(decodeWithKeyAndShift(otpResponse.data));

                        const res = decodedData.Name
                        setSHowSpinner(false);
                        if (res.txnId) {
                            setOtpTxnId(res.txnId);
                            setIsOTPErrorCheck(false);
                            setResData(res);
                            setResAadharData(res);
                            if (res.txnId) {
                                const data = {
                                    "txnId":res.txnId
                                }
                                try {
                                    setSHowSpinner(true);
                                    const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                                    const otpResponse = await postDataJSON<any>(`${endpoints.verifyHPRIdExist}`, { data: encodedPayload })

                                    const decodedData = JSON.parse(decodeWithKeyAndShift(otpResponse.data));

                                    const response = decodedData
                                    const name = res.name;
                                    let concatEnteredName = '';
                                    if (hasMultipleWords(name)) {
                                        concatEnteredName = `${fName} ${lName}`;
                                    }
                                    else {
                                        concatEnteredName = `${fName}`;
                                    }
                                    const resHpr = response?.hprIdNumber?.replace(/-/g, "");
                                    const areEqualHPR = idValue === resHpr;
                                    setSHowSpinner(false);
                                    const isNameSimilar = calculateStringSimilarity(name, concatEnteredName);
                                    if (areEqualHPR && isNameSimilar) {
                                        setSaveContent3(true);
                                        setSaveContent2(false);
                                        setHprMessage('Your HPR ID has been verified')
                                        handleVerify(true, idValue);
                                        dispatch(updateForm("consentDetails", consentLanguageData));
                                    }
                                    else {
                                        setHprMessage('Your HPR ID  not verified.Entered incorrect HPR ID / First Name / Last Name. Please check again and proceed.')
                                        setSaveContent3(true);
                                        setSaveContent2(false);
                                        handleVerify(false, idValue);
                                    }
                                }
                                catch (error:any) {
                                    errorLogger(error,"HPR ID Exists-verifyHPRIdExist");
                                    setHprMessage('Unable to contact ABDM services. Please try again after some time.');
                                    setSaveContent3(true);
                                    setSaveContent2(false);
                                    handleVerify(false, idValue);
                                    const errorData=error?.response?.data?.data;
                                    if(errorData){
                                        if(errorData?.code && errorData?.message && errorData?.details?.length>0){
                                        const errorMessage = (<div>
                                            <p><strong>ABDM:</strong> {`${(errorData?.details[0]?.code||errorData?.code)} ${(errorData?.details[0]?.message||errorData?.message)}`}</p >
                                        </div>);
                                        toast.error(errorMessage, {
                                            position: "top-center",
                                        });
                                        }
                                        else if(errorData?.code && errorData?.message){
                                        const errorMessage = (<div>
                                            <p><strong>ABDM:</strong> {`${errorData?.code} ${errorData?.message}`}</p >
                                        </div>);
                                        toast.error(errorMessage, {
                                            position: "top-center",
                                        });
                                        }
                                        else if((errorData?.message||errorData?.code)&& errorData?.details){
                                            const errorMessage = (<div>
                                                <p><strong>ABDM:</strong> {`${(errorData?.message||errorData?.code)} ${errorData?.details}`}</p >
                                            </div>);
                                            toast.error(errorMessage, {
                                                position: "top-center",
                                            });
                                        }
                                        else if(errorData?.code|| errorData?.message||errorData?.details||errorData?.data||errorData){
                                            const errorMessage = (<div>
                                                <p><strong>ABDM:</strong> {errorData?.code||errorData?.message || errorData?.details||errorData?.data||errorData}</p >
                                            </div>);
                                            toast.error(errorMessage, {
                                                position: "top-center",
                                            });
                                        }
                                    }
                                    else{
                                        const errorMessage = (<div>
                                                <p><strong>ABDM:</strong> {error?.response?.data?.data||error?.response?.data||error?.response||error}</p >
                                            </div>);
                                            toast.error(errorMessage, {
                                                position: "top-center",
                                            });
                                    }
                                }
                            }
                        }
                        else {
                            if (retry >= 0) {
                                setOtpWrong('Invalid OTP ')
                            }
                            else {
                                setOtpWrong('Invalid OTP ')
                                setHprMessage('Maximum limit to resend OTP is reached. Please try after some time.')
                                setSaveContent3(true);
                                setSaveContent2(false);
                                handleVerify(false, idValue);
                            }
                        }
                    }
                    catch (error: any) {
                        setSHowSpinner(false);
                        if (retry >= 0) {
                            setOtpWrong('Invalid OTP ');
                            errorLogger(error?.response?.data?.data||error?.response?.data||error?.response||error,"HPR ID Exists-verifyHPRIdExist");
                        }
                        else {    
                            errorLogger(error?.response?.data?.data||error?.response?.data||error?.response||error,"HPR ID Exists-verifyHPRIdExist");
                            setHprMessage('Unable to contact ABDM services. Please try again after some time.');
                            setSaveContent3(true);
                            setSaveContent2(false);
                            handleVerify(false, idValue);
                            setOtpWrong('Invalid OTP ');
                        }
                    }
                }
            }
        }
        else if (userTypeData === 'Field Level User' || (userTypeData === 'Facility Level User' && userDesignationData === 'MPW/MPHW')) {
            if (selectedInputFieldValue.length === 6) {
                const result = Object.values(selectedInputFieldValue).join('');
                if (inputValue && isAbhaCreate) {
                    const data = {
                        "otp": result,
                        "txnId": aadharTxnId,
                        "mobileNumber": mobileValue
                    }
                    let resAbha1;
                    try {
                        setSHowSpinner(true);
                        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                        const otpResponse = await postDataJSON<any>(`${endpoints.createAbhaViaAadhaarVerify}`, { data: encodedPayload })
                        const decodedData = JSON.parse(decodeWithKeyAndShift(otpResponse.data));
                        const res = decodedData
                        resAbha1 = res.ABHAProfile.ABHANumber.replace(/-/g, "");

                        setSHowSpinner(false);
                        if (res.txnId) {
                            setOtpTxnId(res.txnId);
                            setIsOTPErrorCheck(false);
                            setResData(res);

                            if (res.txnId) {
                                const firstName = res.ABHAProfile.firstName;
                                const middleName = res.ABHAProfile.middleName;
                                const lastName = res.ABHAProfile.lastName;
                                const concatABHAName = `${firstName} ${middleName} ${lastName}`;
                                let concatEnteredName;
                                if (hasMultipleWords(concatABHAName)) {
                                    concatEnteredName = `${fName} ${lName}`;
                                }
                                else {
                                    concatEnteredName = `${fName}`;
                                }

                                const isNameSimilar = calculateStringSimilarity(concatABHAName, concatEnteredName);
                                const resAbha = res.ABHAProfile.ABHANumber.replace(/-/g, "");

                                try {
                                    setSHowSpinner(true);
                                    const dataAbha = {
                                        abhaId: resAbha
                                    }
                                    const encodedNumber = encodeWithKeyAndShift(JSON.stringify(dataAbha));
                                    const abhaResponse = await postDataJSON<any>(`${endpoints.checkABHAIdExists}`, { data: encodedNumber });
                                    const decodedResponse = JSON.parse(decodeWithKeyAndShift(abhaResponse.data));

                                    const abhaRes = decodedResponse[0];
                                    const abhaFlag = abhaRes.check_abha_id_exists;
                                    setSHowSpinner(false);
                                    if (abhaFlag) {
                                        setAbhaMessage('Entered  Abha number is already linked with another user.')
                                        setSaveContent3(true);
                                        setSaveContent2(false);
                                        handleVerify(false, resAbha);
                                    }
                                    else {
                                        if (resAbha && isNameSimilar) {
                                            setSaveContent3(true);
                                            setSaveContent2(false);
                                            setAbhaMessage('Your Abha Number has been Verified')
                                            handleVerify(true, resAbha);
                                        }
                                        else {
                                            const resAbha = res.ABHAProfile.ABHANumber.replace(/-/g, "");
                                            setAbhaMessage('Your Abha Number not verified. Entered incorrect Abha Number / First Name / Last Name. Please check again and proceed.')
                                            setSaveContent3(true);
                                            setSaveContent2(false);
                                            handleVerify(false, resAbha);
                                        }
                                    }
                                }
                                catch (error:any) {
                                    const resAbha = res.ABHAProfile.ABHANumber.replace(/-/g, "");
                                    errorLogger(error?.response?.data?.messages,"Abha ID Exists-checkABHAIdExists");
                                    setAbhaMessage('Failed to verify Abha Number internally. Please try again');
                                    setSaveContent3(true);
                                    setSaveContent2(false);
                                    handleVerify(false, resAbha);
                                }
                                //if(areEqualFirstName && areEqualLastName && resAbha){
                            }
                            else {
                                const resAbha = res.ABHAProfile.ABHANumber.replace(/-/g, "");
                                setAbhaMessage('Your Abha Number not verified. Entered incorrect Abha Number / First Name / Last Name. Please check again and proceed.')
                                setSaveContent3(true);
                                setSaveContent2(false);
                                handleVerify(false, resAbha);
                            }

                        }
                        else {
                            if (retry >= 0) {
                                setOtpWrong('Invalid OTP ')
                            }
                            else {
                                setOtpWrong('Invalid OTP ')
                                setAbhaMessage('Maximum limit to resend OTP is reached. Please try after some time.')
                                setSaveContent3(true);
                                setSaveContent2(false);
                                handleVerify(false, resAbha1);
                            }
                        }
                    }
                    catch (error:any) {
                        const decodedData = JSON.parse(decodeWithKeyAndShift(error?.response?.data));
                        const res = decodedData;
                        setSHowSpinner(false);
                        if (retry >= 0) {
                            setOtpWrong('Invalid OTP ')
                        }
                        else {
                            setOtpWrong('Invalid OTP ')
                            errorLogger(res,"Abha verify-createAbhaViaAadhaarVerify");
                            setAbhaMessage('Unable to contact ABDM services. Please try again after some time.');
                            setSaveContent3(true);
                            setSaveContent2(false);
                            handleVerify(false, resAbha1);
                        }

                    }
                }
                else if (inputAbha) {
                    const data = {
                        "otp": result,
                        "txnId": abhaTxnId
                    }
                    try {
                        setSHowSpinner(true);
                        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                        const otpResponse = await postDataJSON<any>(`${endpoints.verifyOtpToAbhaToVerifyAbha}`, { data: encodedPayload })
                        const decodedData = JSON.parse(decodeWithKeyAndShift(otpResponse.data));

                        const res = decodedData[0];
                        setSHowSpinner(false);

                        if (res.authResult === 'success') {
                            // setOtpTxnId(res.authResult);
                            setIsOTPErrorCheck(false);
                            setResData(res);
                            if (res.authResult === 'success') {
                                const firstName = fName.toLowerCase().trim();
                                const lastName = lName.toLowerCase().trim();
                                const ABHAname = res.accounts[0].name;
                                let concatEnteredName = '';
                                if (hasMultipleWords(ABHAname)) {
                                    concatEnteredName = `${firstName} ${lastName}`;
                                }
                                else {
                                    concatEnteredName = `${firstName}`;
                                }
                                const isNameSimilar = calculateStringSimilarity(ABHAname, concatEnteredName);

                                const resAbha = res?.accounts[0].ABHANumber?.replace(/-/g, "");
                                const areEqualABHA = inputAbha === resAbha;

                                if (areEqualABHA && isNameSimilar) {
                                    setSaveContent3(true);
                                    setSaveContent2(false);
                                    setAbhaMessage('Your Abha Number has been verified')
                                    handleVerify(true, inputAbha);
                                }
                                else {
                                    setAbhaMessage('Your Abha Number  not verified. Entered incorrect Abha Number / First Name / Last Name. Please check again and proceed.')
                                    setSaveContent3(true);
                                    setSaveContent2(false);
                                    handleVerify(false, inputAbha);
                                }
                            }
                            else {
                                setAbhaMessage('Your Abha Number  not verified. Entered incorrect Abha Number / First Name / Last Name. Please check again and proceed.')
                                setSaveContent3(true);
                                setSaveContent2(false);
                                handleVerify(false, inputAbha);
                            }
                        }
                        else {
                            if (retry >= 0) {
                                setOtpWrong('Invalid OTP ')
                            }
                            else {
                                setOtpWrong('Invalid OTP ')
                                setAbhaMessage('Maximum limit to resend OTP is reached. Please try after some time.')
                                setSaveContent3(true);
                                setSaveContent2(false);
                                handleVerify(false, inputAbha);
                            }

                        }
                    }
                    catch (error:any) {
                        const decodedData = JSON.parse(decodeWithKeyAndShift(error?.response?.data));
                        const res = decodedData;
                        setSHowSpinner(false);
                        if (retry >= 0) {
                            setOtpWrong('Invalid OTP ')
                        }
                        else {
                            setOtpWrong('Invalid OTP ')
                            errorLogger(res,"Abha verify-verifyOtpToAbhaToVerifyAbha");
                            setAbhaMessage('Unable to contact ABDM services. Please try again after some time.');
                            setSaveContent3(true);
                            setSaveContent2(false);
                            handleVerify(false, inputAbha);
                        }

                    }
                }
            }
        }

    }
    //create abha flow save
    const handleSaveAdhar = async () => {
        setIsAbhaCreate(true);

        if (inputValue.length !== 12) {
            setIsAadharErrorCheck(true);
            setAadharErrorMessage("Aadhaar number Must Contain 12 Digits. Enter a valid Aadhaar number.")
            setIsAadharError(true);
            isError[0] = true;
        }
        else {
            setIsAadharErrorCheck(false);
            setIsAadharError(false);
            isError[0] = false;
        }
        if (mobileValue.length !== 10) {
            setMobileErrorMessage("Mobile number Must Contain 10 Digits. Enter a valid Mobile number.")
            setIsMobileError(true);
            isError[1] = true;
        }
        else {
            setIsMobileError(false);
            isError[1] = false;

        }
        if (isError[1] === false && isError[0] === false && consentCheckbox) {

            const data = {
                "aadhaar": inputValue
            }
            try {
                setSHowSpinner(true);
                const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                const aadharResponse = await postDataJSON<any>(`${endpoints.createAbhaViaAadhaar}`, { data: encodedPayload })
                const decodedData = JSON.parse(decodeWithKeyAndShift(aadharResponse.data));
                const res = decodedData;
                setResData(res);
                setSHowSpinner(false);
                if (res.txnId) {
                    setAadharTxnId(res.txnId);
                    setError(false);
                    setSaveContent2(true);
                    setSaveContent5(false);
                    const consentDetails = [
                        ...consentLanguageData.data[0].map((item:any) => ({
                            consent_template_id: item.consent_template_id,
                            conscent_template_content: item?.consent_template_content.includes('{#name#}')
                            ? item?.consent_template_content.replace(
                                '{#name#}',
                                `${fName} ${lName}`
                            )
                            : item?.consent_template_content
                        })),
                    ];
                    dispatch(updateForm("consentDetails", consentDetails));
                }
                else {
                     if (res?.message?.includes('multiple OTPs')) {
                        setSHowSpinner(false);
                        setAadharErrorMessage("You have requested multiple OTPs Or Exceeded maximum number of attempts for OTP match in this transaction. Please try again in 30 minutes.")
                        setIsAadharError(true);
                        const errorMessage = (<div>
                        <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                        </div>);
                        toast.error(errorMessage, {
                            position: "top-center",
                        });
                    }
                    else if (res?.message?.includes('30 seconds')) {
                        setSHowSpinner(false);
                        setAadharErrorMessage("You can request for new OTP after 30 seconds.")
                        setIsAadharError(true);
                        const errorMessage = (<div>
                        <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                        </div>);
                        toast.error(errorMessage, {
                            position: "top-center",
                        });
                    }
                    else if (res?.message?.includes('Too many request attempted')) {
                        setSHowSpinner(false);
                        setAadharErrorMessage("Too many request attempted in short period of time. Please try again in 30 minutes.")
                        setIsAadharError(true);
                        const errorMessage = (<div>
                        <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message}`}</p >
                        </div>);
                        toast.error(errorMessage, {
                            position: "top-center",
                        });
                    }
                    else if (res?.message?.includes('Aadhaar number is incorrect')||res?.code?.includes('ABDM-1204')||res?.loginId?.includes('Invalid LoginId')) {
                        setSHowSpinner(false);
                        setAadharErrorMessage("Entered Aadhaar number is incorrect. Please enter correct Aadhaar number.")
                        setIsAadharError(true);
                        const errorMessage = (<div>
                        <p><strong>ABDM:</strong> {`${res?.code?res?.code:''} ${res?.message?res?.message:''} ${res?.loginId?res?.loginId:''}`}</p >
                        </div>);
                        toast.error(errorMessage, {
                            position: "top-center",
                        });
                    }
                    else{
                        setAadharErrorMessage("Unable to contact ABDM services. Please try again after some time.");
                        errorLogger(res,"Aadhar OTP Generation ERROR-createAbhaViaAadhaar");
                        setSHowSpinner(false);
                        setIsAadharError(true);
                        const errorMessage = (<div>
                        <p><strong>ABDM:</strong> {((res?.code && res?.message)||(res?.code || res?.message || res?.loginId))? (`${res?.code?res?.code:''} ${res?.message?res?.message:''} ${res?.description?res?.description:''} ${res?.loginId?res?.loginId:''}`):JSON.stringify(res)}</p >
                        </div>);
                        toast.error(errorMessage, {
                            position: "top-center",
                        });
                    }
                }
            }
            catch (error:any) {
                if (isOtpRateLimitedError(error)) {
                    aadhaarCooldown.startCooldown();
                    setSHowSpinner(false);
                    setIsAadharErrorCheck(true);
                    setIsAadharError(true);
                    setAadharErrorMessage("You can request for new OTP after 30 seconds.");
                    toast.error(otpCooldownMessage, { position: "top-center" });
                    return;
                }
                if(error?.response?.data){
                const decodedData = JSON.parse(decodeWithKeyAndShift(error?.response?.data));
                const res = decodedData;
                setSHowSpinner(false);
                setIsAadharErrorCheck(true);
                errorLogger(res,"Aadhar OTP Generation ERROR-createAbhaViaAadhaar");
                setAadharErrorMessage("Unable to contact ABDM services. Please try again after some time.");
                setIsAadharError(true);
                const errorMessage = (<div>
                <p><strong>ABDM:</strong> {((res?.code && res?.message)||(res?.code || res?.message))? (`${res?.code?res?.code:''} ${res?.message?res?.message:''} ${res?.description?res?.description:''}`):res?.data?(res?.data?.code || res?.data?.message||res?.data?.description)?`${res?.data?.code?res?.data?.code:''} ${res?.data?.message?res?.data?.message:''} ${res?.data?.description?res?.data?.description:''}`:res?.data:res}</p >
                </div>);
                toast.error(errorMessage, {
                    position: "top-center",
                });
            }
            else{
                setSHowSpinner(false);
                setIsAadharErrorCheck(true);
                setIsAadharError(true);
                setAadharErrorMessage("Unable to contact ABDM services. Please try again after some time.");
                toast.error(error, {
                    position: "top-center",
                });
            }
            }
        }
    }

    const handleSave = () => {

    }
    const cardPageContent1 = (
        <div className="card-page-content1">
            {(userTypeData === "Facility Level User"  && userDesignationData !== 'MPW/MPHW') && <>
                <InputFieldsComponent
                    labelName="HPR ID"
                    placeholder={"Type Here"}
                    type={'text'}
                    isDisabled={true}
                    errorMessage={hprErrorMessage}
                    inputType={isHPRError ? 'error' : 'general'}
                    value={idValue ? idValue : hfrAbhaId}
                    onChange={handleFormChange}
                    required={true} />
                <InputFieldsComponent
                    labelName="Aadhaar Number"
                    placeholder={"Type Here"}
                    type={'text'}
                    isDisabled={false}
                    errorMessage={aadharErrorMessage}
                    inputType={isAadharError ? 'error' : 'general'}
                    onChange={handleAadharChange}
                    required={true}
                    value={inputValue}
                />
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '5px' }}>
                    <CheckboxComponent
                        className="align-item_check_box"
                        checkBoxName=""
                        disabled={false}
                        onCheckboxChange={() => { }}
                        placeCheckboxBefore={false}
                        isChecked={facilityLevelConsentCheckbox}
                    />
                    <p>I hereby confirm that I agree to the {' '}
                        <button onClick={showConsentFormFacilityLevel}
                            className="aadhar_consent_form"
                            disabled={!inputValue.length || !idValue.length}> Consent Process </button> for
                        the creation of ABHA and linking with JANANI programme/application</p>
                </div>
                <span>{showSpinner && (<><span>Loading...</span><Spinner /></>)} </span>
                <div className="content1-buttons">
                    <Button
                        onClick={handleSave1}
                        disabled={!idValue.length || !inputValue.length || !facilityLevelConsentCheckbox}
                        id=""
                        buttonName={'Next'}
                        colorType={'primary'}
                        icon={''}
                        iconPosition={''} />
                    {/* <Button
                        onClick={handleNext1}
                        disabled={error ? true : false}
                        id=""
                        buttonName={'Next'}
                        colorType={'disabled'}
                        icon={''}
                        iconPosition={''} /> */}
                </div>
            </>}
            {(userTypeData === 'Field Level User' || (userTypeData === 'Facility Level User' && userDesignationData === 'MPW/MPHW'))&&
                <div className="button-container">
                    <div className="button-wrapper">
                        <button id="imgbutton" onClick={showAbha}><img data-testid="abha-verification" id="img" src={abhaImg} alt="ABHA Button" /></button>
                        <p>ABHA Verification</p>
                    </div>
                    <div className="button-wrapper">
                        <button id="imgbutton" onClick={showAadhar}><img data-testid="aadhaar-verification" id='img' src={aadharImg} alt="ABHA Button" /></button>
                        <p>Create ABHA with Aadhaar Number</p>
                    </div>
                    {userTypeData === 'Field Level User' && userDesignationData === 'ASHA' && (
                        <div className="button-wrapper">
                            <button id="imgbutton" data-testid="aadhaar-mobile-verification" onClick={showAadharMobile}><FaceAuthImg id='img' /></button>
                            <p>Face Authentication</p>
                        </div>
                    )}
                </div>
            }
        </div>
    )
    const handleOTPInputFieldChange = (value: string, index: number) => {
        const newSelectedInputField = [...selectedInputFieldValue];
        setIsOTPErrorCheck(true);

        if (value.trim()) {
            newSelectedInputField[index] = value.trim();
            setSelectedInputFieldValue(newSelectedInputField);
            setIndex(index + 1);
            const nextInput = document.getElementById(`otp-hpr-abha-${index + 1}`);
            nextInput?.focus();
        }
        else {
            newSelectedInputField[index] = '';
            setSelectedInputFieldValue(newSelectedInputField);
            setIndex(index - 1);
        }
    }
    const cardPageContent2 = (
        <div className="card-page-content2">
            <p style={{ fontSize: '11px' }}>An OTP has been sent to your Registered Mobile Number</p>
            <h2 style={{ fontSize: '14px' }}>Enter OTP</h2>
            <div className="otp-page-content">

                {Array.from({ length: 6 }).map((_, index) => (
                    <div className="otp-page-content-input-fields" key={index}>
                        <InputFieldsComponent
                            className={
                                selectedInputFieldValue[index]
                                    ? 'ip-fields-has-value'
                                    : 'ip-fields'
                            }
                            placeholder={'_'}
                            type={'number'}
                            isDisabled={false}
                            inputId={`otp-hpr-abha-${index}`}
                            onChange={(value: string) => handleOTPInputFieldChange(value, index)}
                            maximumLength={1}
                        />
                    </div>
                ))}
            </div>
            {saveContent2 &&
                <div className="otp-resend">
                    <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>

                        <h2 style={{ fontSize: '14px' }}>Didn't receive an OTP</h2>
                        <span> {isTimeFinished ?
                            <Button
                                onClick={restartTimer}
                                disabled={abhaCooldown.isCoolingDown || aadhaarCooldown.isCoolingDown}
                                id=""
                                buttonName={'Resend OTP'}
                                colorType={'save'}
                                icon={''}
                                iconPosition={''}
                            /> : <div className="divbutton">
                                <Button
                                    onClick={handleSave}
                                    disabled={true}
                                    id=""
                                    buttonName={`${otpWrong} Resend OTP in`}
                                    colorType={'save'}
                                    icon={''}
                                    iconPosition={''}
                                />
                            </div>

                        }</span>


                        <span><Time startTime={60} resetKey={resetKey} onTImeEnd={handleTimerEnd} /></span>
                    </div>
                    <span className="no_of_retries_resend_otp">Retries left : {retry >= 0 ? retry : 0}</span>
                    <span className="no_of_retries_resend_otp">{retryMessage}</span>
                    {(abhaCooldown.isCoolingDown || aadhaarCooldown.isCoolingDown) && (
                        <p style={{ color: '#b42318', fontSize: '12px', margin: '8px 0 0' }}>
                            You can request for new OTP after {abhaCooldown.isCoolingDown ? abhaCooldown.secondsLeft : aadhaarCooldown.secondsLeft} seconds
                        </p>
                    )}
                </div>}
            <span>{showSpinner && (<><span>Loading...</span><Spinner /></>)} </span>
            <div className="content1-buttons">
                <Button
                    onClick={handleSave2}
                    disabled={false}
                    id=""
                    buttonName={'Submit'}
                    colorType={'save'}
                    icon={''}
                    iconPosition={''}
                />
            </div>
        </div>
    )
    const cardPageContent3 = (
        <div className="card-page-content1" >
            <div style={{ display: "flex", flexDirection: "column", justifyContent: 'center', alignItems: 'center', marginBottom: '40px', marginTop: '40px' }}>
                <img src={finish} alt="Done" style={{ height: '50px', width: '50px', display: 'inline-block' }} />
                {(userTypeData === 'Facility Level User' && userDesignationData !== 'MPW/MPHW') ? <p>{hprMessage}</p> : <p>{abhaMessage}</p>}
            </div>
            <div className="content1-buttons">
                <Button
                    onClick={handleLast}
                    disabled={false}
                    id=""
                    buttonName={'Close'}
                    colorType={'disabled'}
                    icon={''}
                    iconPosition={''} /></div>
        </div>
    )
    const cardPageContent4 = (
        <div className="card-page-content1">
            <InputFieldsComponent
                labelName="ABHA Number"
                placeholder={"Type Here"}
                type={'text'}
                isDisabled={false}
                onChange={handleFormChangeAbha}
                errorMessage={abhaErrorMessage}
                value={inputAbha ? inputAbha : hfrAbhaId}
                inputType={isAbhaError ? 'error' : 'general'}
                required={true} />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '5px' }}>
                <CheckboxComponent
                    className="align-item_check_box"
                    checkBoxName=""
                    disabled={false}
                    onCheckboxChange={() => { }}
                    placeCheckboxBefore={false}
                    isChecked={consentCheckbox}
                />
                {/* <FormFields
                    formData={abhaVerify}
                    formState={roleFormState}
                    handleFormChange={handleCheckBox}
                /> */}
                <p>I hearby confirm that I agree to the {' '}
                    <button onClick={showAbhaConsentForm}
                        className="aadhar_consent_form"
                        disabled={!inputAbha?.length}> Consent Process</button> for
                    the creation of ABHA and linking with JANANI programme/application</p>
            </div>
            <span>{showSpinner && (<><span>Loading...</span><Spinner /></>)} </span>
            {abhaCooldown.isCoolingDown && (
                <p style={{ color: '#b42318', fontSize: '12px', margin: '8px 0 0' }}>
                    You can request for new OTP after {abhaCooldown.secondsLeft} seconds
                </p>
            )}
            <div className="content1-buttons">
                <Button
                    onClick={handleSaveAbha}
                    disabled={abhaCooldown.isCoolingDown || !consentCheckbox || !inputAbha?.length}
                    id=""
                    buttonName={'Next'}
                    colorType={'primary'}
                    icon={''}
                    iconPosition={''} />
                {/* <Button
                    onClick={handleNext4}
                    disabled={error ? true : false}
                    id=""
                    buttonName={'Next'}
                    colorType={'disabled'}
                    icon={''}
                    iconPosition={''} /> */}
            </div>

        </div>
    )
    const cardPageContent5 = (
        <div className="card-page-content1">
            <InputFieldsComponent
                labelName="Aadhaar Number"
                placeholder={"Type Here"}
                type={'text'}
                isDisabled={false}
                onChange={handleAadharChange}
                errorMessage={aadharErrorMessage}
                inputType={isAadharError ? 'error' : 'general'}
                value={inputValue}
                required={true} />
            <InputFieldsComponent
                labelName="Mobile Number Linked with Aadhaar"
                placeholder={"Type Here"}
                type={'text'}
                isDisabled={false}
                errorMessage={mobileErrorMessage}
                inputType={isMobileError ? 'error' : 'general'}
                onChange={handleMobileChange}
                value={mobileValue}
                required={true} />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '5px' }}>
                <CheckboxComponent
                    className="align-item_check_box"
                    checkBoxName=""
                    disabled={false}
                    onCheckboxChange={() => { }}
                    placeCheckboxBefore={false}
                    isChecked={consentCheckbox}
                />
                {/* <FormFields
                    formData={abhaVerify}
                    formState={roleFormState}
                    handleFormChange={handleCheckBox}
                /> */}
                <p>I hearby confirm that I agree to the {' '}
                    <button onClick={showAdharConsentForm}
                        className="aadhar_consent_form"
                        disabled={!inputValue.length || !mobileValue.length}> Consent Process</button> for
                    the creation of ABHA and linking with JANANI programme/application</p>
            </div>
            <span>{showSpinner && (<><span>Loading...</span><Spinner /></>)} </span>
            {aadhaarCooldown.isCoolingDown && (
                <p style={{ color: '#b42318', fontSize: '12px', margin: '8px 0 0' }}>
                    You can request for new OTP after {aadhaarCooldown.secondsLeft} seconds
                </p>
            )}
            <div className="content1-buttons">
                <Button
                    onClick={handleSaveAdhar}
                    disabled={aadhaarCooldown.isCoolingDown || !inputValue.length || !mobileValue.length || !consentCheckbox}
                    id=""
                    buttonName={'Next'}
                    colorType={'primary'}
                    icon={''}
                    iconPosition={''} />
                {/* <Button
                    onClick={handleAadharVerify}
                    disabled={error ? true : false}
                    id=""
                    buttonName={'Next'}
                    colorType={'disabled'}
                    icon={''}
                    iconPosition={''} /> */}
            </div>

        </div>
    )
    const handleCheckboxChange = (index: number, checked: boolean) => {
        const updatedCheckedState = [...checkedState];
        updatedCheckedState[index] = checked;
        setCheckedState(updatedCheckedState);
    };

    const handleSelectAll = (checked: boolean) => {
        setCheckedState(new Array(checkedState?.length).fill(checked));
    };

    const handleCheckStateFacility = (checked: boolean) => {
        setCheckedStateFacility(checked)
    }
    return (
        <div className="verification_card_component">
            {saveContent1 && (
                <div className="verification-page-one">
                    <CommonCardComponent
                        cardHeader={userTypeData === 'Facility Level User' && userDesignationData !== 'MPW/MPHW' ? 'HPR Verification' : 'ABHA Verification'}
                        cardBodyContent={cardPageContent1}
                    />
                </div>
            )}
            {saveContent2 && (
                <div className="verification-page-two">
                    <CommonCardComponent
                        cardHeader={userTypeData === 'Facility Level User' && userDesignationData !== 'MPW/MPHW' ? 'HPR Verification' : 'ABHA Verification'}
                        cardBodyContent={cardPageContent2}
                    />
                </div>
            )}
            {saveContent3 && (
                <div className="verification-page-three">
                    <CommonCardComponent
                        cardHeader={''}
                        cardBodyContent={cardPageContent3}
                    />
                </div>
            )}
            {saveContent4 && (
                <div className="verification-page-four">
                    <CommonCardComponent
                        cardHeader={"ABHA Verification"}
                        cardBodyContent={cardPageContent4}
                    />
                </div>
            )}
            {saveContent5 && (
                <div className="verification-page-five">
                    <CommonCardComponent
                        cardHeader={"Create ABHA with Aadhaar Number"}
                        cardBodyContent={cardPageContent5}
                    />
                </div>
            )}
            {saveContent7 && (
                <div className="verification-page-seven">
                    <AadharModal
                        handleClose={handleFaceAuthModalClose}
                        setLinkedBenefDetails={setDummyLinkedBenefDetails}
                    />
                </div>
            )}
            {showFaceAuthModal && (
                <FaceAuthenticationModal
                    showModal={showFaceAuthModal}
                    handleClose={closeFaceAuthModal}
                    skipGenderCheck={true}
                />
            )}
            {/* facility level consent */}
            {/* {
                consentShowFacilityLevel && !saveContent1 && (
                    <div className="verification-page-six">
                    <CommonCardComponent
                        cardHeader={"Consent Process"}
                        cardBodyContent={facilityLevelConsent}
                    />
                </div>
                )
            } */}

            {consentShowFacilityLevel && !saveContent1 && (
                <div className="verification-page-six">
                    <div className="aadhar_consent_form_enlarge">
                        <h1 className="aadhar_headings">Consent Process</h1>
                        <div className="consent_form_for_aadhar">
                            <CheckboxComponent
                                className=""
                                checkBoxName={consentLanguageData[0].conscent_template_content}
                                disabled={false}
                                isChecked={checkedStateFacility}
                                onCheckboxChange={handleCheckStateFacility}
                                placeCheckboxBefore={false}
                            />
                        </div>
                        <div className="aadhar-submit">
                            <Button
                                onClick={handletoAadharFacilityLevel}
                                disabled={!checkedStateFacility}
                                id="aadhar-beneficiary-submit"
                                buttonName={'Submit'}
                                colorType={'primary'}
                                icon={''}
                                iconPosition={''}
                            />
                        </div>
                    </div>
                </div>
            )
            }

            {/* Adhar Level Consent */}
            {consentShowAdhar && (
                <div className="verification-page-six">
                    {/* <CommonCardComponent
                        cardHeader={"Consent Process"}
                        cardBodyContent={AdharPageContent6}
                    /> */}
                    <div className="aadhar_consent_form_enlarge">
                        <h1 className="aadhar_headings">Consent Process</h1>
                        <div className="consent_form_for_aadhar">
                            I hereby declare that:
                            {/* Select All Checkbox */}
                            <CheckboxComponent
                                isChecked={isAllChecked}
                                onCheckboxChange={handleSelectAll}
                                disabled={false}
                                className="consent-select-all"
                                checkBoxName="Select All"
                            />
                            {/* Individual Checkboxes */}
                            {consentLanguageData?.data[0]?.map((item: any, index: any) => (
                                <CheckboxComponent
                                    key={index}
                                    isChecked={checkedState?.[index]}
                                    onCheckboxChange={(checked) =>
                                        handleCheckboxChange(index, checked)
                                    }
                                    disabled={false}
                                    className={`consent-checkbox-item`}
                                    checkBoxName={
                                        item?.consent_template_content.includes('{#name#}')
                                            ? item?.consent_template_content.replace(
                                                '{#name#}',
                                                `${fName} ${lName}`
                                            )
                                            : item?.consent_template_content
                                    }
                                />
                            ))}
                        </div>
                        <div className="aadhar-submit">
                            <Button
                                onClick={handletoAadharFieldLevel}
                                disabled={isAllChecked ? false : true}
                                id="aadhar-beneficiary-submit"
                                buttonName={'Submit'}
                                colorType={'primary'}
                                icon={''}
                                iconPosition={''}
                            />
                        </div>
                    </div>
                </div>
            )}

            {/* Abha level consent */}
            {consentShowAbha && (
                <div className="verification-page-six">
                    {/* <CommonCardComponent
                        cardHeader={"Consent Process"}
                        cardBodyContent={AdharPageContent6}
                    /> */}
                    <div className="aadhar_consent_form_enlarge">
                        <h1 className="aadhar_headings">Consent Process</h1>
                        <div className="consent_form_for_aadhar">
                            I hereby declare that:
                            {/* Select All Checkbox */}
                            <CheckboxComponent
                                isChecked={isAllChecked}
                                onCheckboxChange={handleSelectAll}
                                disabled={false}
                                className="consent-select-all"
                                checkBoxName="Select All"
                            />
                            {/* Individual Checkboxes */}
                            {consentLanguageData?.data[0]?.map((item: any, index: any) => (
                                <CheckboxComponent
                                    key={index}
                                    isChecked={checkedState?.[index]}
                                    onCheckboxChange={(checked) =>
                                        handleCheckboxChange(index, checked)
                                    }
                                    disabled={false}
                                    className={`consent-checkbox-item`}
                                    checkBoxName={
                                        item?.consent_template_content.includes('{#name#}')
                                            ? item?.consent_template_content.replace(
                                                '{#name#}',
                                                `${fName} ${lName}`
                                            )
                                            : item?.consent_template_content
                                    }
                                />
                            ))}
                        </div>
                        <div className="aadhar-submit">
                            <Button
                                onClick={handletoAbhaFieldLevel}
                                disabled={isAllChecked ? false : true}
                                id="aadhar-beneficiary-submit"
                                buttonName={'Submit'}
                                colorType={'primary'}
                                icon={''}
                                iconPosition={''}
                            />
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};
export default VerificationCard;



